import {
  primaryColor,
  warningColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  blackColor,
} from "assets/jss/material-dashboard-pro-react.js";

const reactTableStyle = {
  phZero: {
    paddingLeft: "0px !important",
    paddingRight: "0px !important",
  },
  tableHeader: {
    display: "flex",
    fontSize: "1.5rem",
    fontWeight: "bold !important",
    alignItems: "center",
    lineHeight: "1",
    paddingLeft: "0px",
    color: blackColor,
    marginBottom: "0px",
  },
  subTitle: {
    fontSize: "1rem",
    color: grayColor[1],
    fontWeight: "600",
  },
  backButton: {
    marginRight: "10px !important",
  },
  floatRight: {
    marginLeft: "auto !important",
    textTransform: "none !important",
  },
};

export default reactTableStyle;
